import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { IsUUID, IsNumber, IsOptional, IsBoolean } from 'class-validator';

export class AddStepDto {
  @ApiProperty({ type: 'string' })
  @IsUUID()
  activityId!: string;

  @ApiProperty({ type: Number })
  @IsNumber()
  orderInPath!: number;

  @ApiPropertyOptional({ type: Boolean })
  @IsOptional()
  @IsBoolean()
  isOptional?: boolean;

  @ApiPropertyOptional({ type: Number })
  @IsOptional()
  @IsNumber()
  minScore?: number;
}

